import { createSlice } from '@reduxjs/toolkit';
import { dispatch } from '../../store';
import { get, post, put } from '../../../inteceptor';
import moment from 'moment';

const initialState = {
  error: null,
  time: null,
  data: [],
  addData: {},
  sorted: [],
};

const slice = createSlice({
  name: 'FoodCategory',
  initialState,
  reducers: {
    // HAS ERROR
    hasError(state, action) {
      state.error = { message: action.payload, time: moment.now().toString() };
    },

    // GET FoodCategoryManagement
    getFoodCategorysSuccess(state, action) {
      state.data = action.payload.data;
    },

    addOrUpdateFoodCategorys(state, action) {
      state.addData = {
        data: action.payload.data,
        time: moment.now().toString(),
      };
    },

    clearAll(state) {
      state.addData = {};
      state.error = {};
    },

    onBackStep(state) {
      state.checkout.activeStep -= 1;
    },

    onNextStep(state) {
      state.checkout.activeStep += 1;
    },

    onGotoStep(state, action) {
      const goToStep = action.payload;
      state.checkout.activeStep = goToStep;
    },
  },
});

// Reducer
export default slice.reducer;

// Actions
export const { filterCategories } = slice.actions;

// ----------------------------------------------------------------------

export function getFoodCategorys(type) {
  return async () => {
    try {
      const response = await get(`FoodCategory?type=${type}`);
      if (response.status) {
        dispatch(slice.actions.getFoodCategorysSuccess(response));
      } else {
        dispatch(slice.actions.hasError(response.message));
      }
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------

export function addFoodCategory(body) {
  return async () => {
    try {
      const response = await post(`FoodCategory`, body);
      if (response.status) {
        dispatch(slice.actions.addOrUpdateFoodCategorys(response));
      } else {
        dispatch(slice.actions.hasError(response.message));
      }
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------

export function updateFoodCategory(body) {
  return async () => {
    try {
      const response = await put(`FoodCategory`, body);
      if (response.status) {
        dispatch(slice.actions.addOrUpdateFoodCategorys(response));
      } else {
        dispatch(slice.actions.hasError(response.message));
      }
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}
